
import {clsx} from 'external/clsx'
import {useMemo, Button, FC} from 'external/react'

import CourseLink from './CourseLink'

type CourseProps = {
    id: string,
    name: string,
    electivesInCart: Array<string>,
    courseSelected: string,
    elective: boolean,
    fromCart: boolean,    
    extra: boolean,
    extraCourseSelected: string,
    handleSelectCourse: (id:string, selected: boolean, extra: boolean) => void
}

const Course : FC<CourseProps> = props => {

    const {courseSelected, id, name, handleSelectCourse, fromCart, extra, extraCourseSelected, elective, electivesInCart} = props

    const selected = courseSelected === id
    const extraSelected = extraCourseSelected === id

    const disabledCourse = useMemo(() => {
        if (fromCart) return false
        return courseSelected && !selected && !extraSelected
    }, [selected, fromCart, courseSelected])

    const [variant, actionLabel] = useMemo(() => {
        if (selected && fromCart) {
            return ['success', 'Seleccionado']
        }
        if (extra && extraSelected) {
            return ['success', 'Complementario']
        }
        if (!elective) { 
            return selected ? ['danger', 'Quitar'] : ['primary', 'Seleccionar']
        }

        if (selected) { return ['danger', 'Quitar'] }
        if (electivesInCart.indexOf(id) >= 0) {
            return ['success', 'Seleccionado']
        }
        return ['primary', 'Seleccionar']

    }, [selected, fromCart, elective, electivesInCart])


    return (
        <div className={clsx('course', {disabled__course: disabledCourse})}>
            <CourseLink id={id} name={name} selected={selected} /> 
            <div className='courseBody'>
                <p>{name}</p>
                <Button disabled={variant === 'success'} className='w-100' variant={variant} size='sm' onClick={() => handleSelectCourse(id, selected, extra)}>
                    {actionLabel}
                </Button>
            </div>
        </div>
    )
}

export {Course as default}